import {Stack} from '@mui/material'

export const FormLayout: React.FC<{children: React.ReactNode}> = ({children}) => {
  return <Stack spacing={3}>{children}</Stack>
}
